import { Actions, Components, Features, Teams } from './heap-attributes';
import { HeapDataAttribute } from './heap-types';

const getHeapDataAttribute = (params: {
    team: Teams;
    feature: Features;
    component: Components;
    action: Actions;
}): HeapDataAttribute => {
    const { team, feature, component, action } = params;

    return `${team}-${feature}-${component}-${action}`;
};

export { getHeapDataAttribute };
